import { useState } from "react";
import { createPost, updatePost } from "actions/postActions";
import { useDispatch } from "react-redux";

const useFormSubmit = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const dispatch = useDispatch();

    const handleCreatePost = async (data) => {
        setError(null);
        setLoading(true);

        try {
            const res = await dispatch(createPost(data));
            return res;
        } catch (err) {
            setError(err.message || "Có lỗi xảy ra");
        } finally {
            setLoading(false);
        }
    };

    
    const handleUpdatePost = async (data) => {
        setError(null);
        setLoading(true);

        try {
            const res = await dispatch(updatePost(data));
            return res;
        } catch (err) {
            setError(err.message || "Có lỗi xảy ra");
        } finally {
            setLoading(false);
        }
    };

    return { handleCreatePost, handleUpdatePost, loading, error };
};

export default useFormSubmit;
